import { render, staticRenderFns } from "./Scolarite.vue?vue&type=template&id=c109f196"
import script from "./Scolarite.vue?vue&type=script&lang=js"
export * from "./Scolarite.vue?vue&type=script&lang=js"
import style0 from "./Scolarite.vue?vue&type=style&index=0&id=c109f196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports